import _ from 'lodash';

import { FadeInAnimation } from '../../shared';

import PropTypes from 'prop-types';

import Router from 'next/router';

import { Button } from '../../shared';

const RoomTypePortfolio = (props) => {
    const { selectedRoomPortfolio } = props;

    const onViewAllClick = () => {
        Router.push('/bookings');
    };

    return (
        <div id="portfolio-section">
            <FadeInAnimation>
                <h3 style={{ marginTop: 200, marginBottom: 20 }}>Managed by {_.get(selectedRoomPortfolio, 'name')}</h3>
                <p className='room-type-portfolio-details'>{_.get(selectedRoomPortfolio, 'details')}</p>
                <Button
                    id="clear-all-button"
                    type="link"                    
                    onClick={onViewAllClick}
                >
                    View All Properties
                </Button>
                <hr className='room-type-portfolio-hr' />
            </FadeInAnimation>
        </div>
    );
};

export default RoomTypePortfolio;

RoomTypePortfolio.propTypes = {
    selectedRoomPortfolio: PropTypes.object,
};

